export default "__VITE_ASSET__CPMTNqFX__"